import React from 'react'
import {Box, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import RadioGroup from 'components/RadioGroup';
import Select, {createSelectItem} from 'components/Select';
import GridBlock from 'components/GridBlock';
import primaryTenderVariantValues from './fieldsOptions/primaryTenderVariant.values'
import pzpExclusionValues from './fieldsOptions/pzpExclusion.values'
import orderTypeValues from 'constants/orderType.values'
import concessionOrderTypeValues from 'constants/concessionOrderType.values'
import booleanValues from 'constants/BooleanItems'
import jedzValues from './fieldsOptions/jedz.values'
import contractTypeValues from './fieldsOptions/contractType.values'
import CPVInput from 'components/CPVInput';
import InputLimits from 'constants/InputLimits';
import HelpComponent from 'components/HelpComponent';
import getObjectValue from 'libs/getObjectValue';
import {isDemandPreparing} from "libs/getDemandStatus";
import OrganizationInput from "components/OrganizationInput";
import UploadFile from "components/UploadFile";
import {isEuropeProcedure, isNationalProcedure, isNonpublicProcedure} from "constants/ProcedureType";
import {PriceTypeItems} from "constants/PriceTypes";
import {DemandCategoryTypeLabel, DemandCategoryTypesForProcedure} from "constants/DemandCategoryType";
import caseClassificationSymbols from './fieldsOptions/caseClassificationSymbol.values'


const limits = InputLimits.procedure.basicInformation;

const style = theme => ({
    root: {},
    uploadFile: {
        marginTop: theme.spacing(4)
    }
})

function RequiredFields(
    {
        classes,
        formikProps,
        demandAvailableOrganizations,
        demandRealizationTypes,
        demandAvailableFormTypes,
        demandHeader,
        numberAutomated,
        caseClassificationSymbolRequired,
        hideExecutiveDemandVariant
    }) {
    const passiveOfferForm = getObjectValue('passiveOfferForm', formikProps.values, false);
    const creatingDemand = getObjectValue('identity', formikProps.values, false) <= 0 || isDemandPreparing();
    //const demandVariant = getObjectValue('demandVariant', formikProps.values, false);
    const procedureType = getObjectValue('procedureType', formikProps.values, "");
    const realizationType = getObjectValue('demandRealizationType', formikProps.values, "");
    const withNotice = realizationType ? demandRealizationTypes.find(x => x.name === realizationType).withNotice : false;
    const europeProcedure = isEuropeProcedure(procedureType);
    const nationalProcedure = isNationalProcedure(procedureType);
    const nonpublicProcedure = isNonpublicProcedure(procedureType);
    const createItem = (prefix, value) => ({label: Tr(prefix + '.' + value), value});
    const demandRealizationTypesTranslated = demandRealizationTypes.map(x => !!x.label ? {value: x.name, label: x.label} : createItem(procedureType, x.name));
    const demandCategoryType = getObjectValue("demandCategoryType", formikProps.values, null);

    const onDemandRealizationTypeChanged = (realizationType) => {

        if (realizationType === 'primary_tender') {
            formikProps.setFieldValue('primaryTenderVariant', primaryTenderVariantValues[0].value);
        }

        const newWithNotice = realizationType ? demandRealizationTypes.find(x => x.name === realizationType).withNotice : false;
        if(!newWithNotice) {
            formikProps.setFieldValue('formType', null);
        }
    };

    return (
        <GridBlock
            column
        >
            <TextInput
                id='number'
                label={Tr('case_number')}
                formikProps={formikProps}
                required
                disabled={numberAutomated}
                limit={limits.NUMBER}
                showErrorImmediately
            />

            {
                (creatingDemand || !!demandCategoryType) && <Select
                    id='demandCategoryType'
                    label={Tr('demand_category_type')}
                    formikProps={formikProps}
                    items={DemandCategoryTypesForProcedure(procedureType).map(x => createSelectItem(x, DemandCategoryTypeLabel(x)))}
                    required
                    disabled={!creatingDemand}
                />
            }

            <Select
                id='caseClassificationSymbol'
                label={Tr('caseClassificationSymbol')}
                formikProps={formikProps}
                items={caseClassificationSymbols}
                required={caseClassificationSymbolRequired}
            />

            {demandHeader.applicationClientSettings.ezdrpIntegration.active &&
                <TextInput
                    id='ezdrpId'
                    label={Tr('case_ezdrpId')}
                    formikProps={formikProps}
                    limit={limits.NUMBER}
                    showErrorImmediately
                />
            }

            {demandHeader.applicationClientSettings.ezdpuwIntegration.active &&
                <TextInput
                    id='ezdpuwId'
                    label={Tr('case_ezdpuwId')}
                    formikProps={formikProps}
                    limit={limits.NUMBER}
                    showErrorImmediately
                />
            }

            <OrganizationInput
                id='organization'
                formikProps={formikProps}
                required
                disabled={!creatingDemand || demandAvailableOrganizations.length < 2}
                availableOrganizations={demandAvailableOrganizations}
           />

            <TextInput
                id='name'
                label={Tr('proceedings_subject')}
                formikProps={formikProps}
                required
                limit={limits.NAME}
                multiline
                showErrorImmediately
            />
            <TextInput
                id='description'
                label={Tr('proceedings_subject_description')}
                formikProps={formikProps}
                required
                multiline
                limit={limits.DESCRIPTION}
            />
            <HelpComponent text={Tr('tooltip_realization_type')}>
                <Select
                    id='demandRealizationType'
                    label={Tr('proposed_procedure')}
                    formikProps={formikProps}
                    items={demandRealizationTypesTranslated}
                    onChange={e => onDemandRealizationTypeChanged(e.target.value)}
                    required
                    disabled={!creatingDemand}
                />
            </HelpComponent>

            {nationalProcedure &&
                <Select
                    id='primaryTenderVariant'
                    label={Tr('primary_tender_variant')}
                    formikProps={formikProps}
                    items={primaryTenderVariantValues}
                    required
                    disabled={!creatingDemand}
                />
            }
            {withNotice &&
            <RadioGroup
                id='formType'
                label={Tr('questionnaire_form')}
                formikProps={formikProps}
                items={demandAvailableFormTypes.map(x=> ({value: x.key, label: x.value}))}
                required
                disabled={!creatingDemand}
            />
            }
            {nonpublicProcedure &&
            <Select
                id='pzpExclusion'
                label={Tr('pzp_exclusion')}
                formikProps={formikProps}
                items={pzpExclusionValues}
            />
            }
            <RadioGroup
                id='demandOrderType'
                label={Tr('order_type')}
                formikProps={formikProps}
                items={procedureType === 'concession' ? concessionOrderTypeValues : orderTypeValues}
                required
            />
            <RadioGroup
                id='demandVariant'
                label={Tr('contract_type')}
                formikProps={formikProps}
                items={contractTypeValues(hideExecutiveDemandVariant)}
                disabled={!creatingDemand}
                required
            />
            {!passiveOfferForm &&
            <HelpComponent text={Tr('tooltip_digital_sign')}>
                <RadioGroup
                    id='digitalSign'
                    label={Tr(europeProcedure ? "electronic_signature_question" : "electronic_signature_national_question")}
                    formikProps={formikProps}
                    items={booleanValues}
                    required
                    disabled={!creatingDemand}
                />
            </HelpComponent>
            }
            {europeProcedure &&
            <HelpComponent text={Tr('tooltip_jedz')}>
                <RadioGroup
                    id='requiredJEDZ'
                    label={Tr('enable_JEDZ_question')}
                    formikProps={formikProps}
                    items={jedzValues}
                    required
                />
            </HelpComponent>
            }
            {!passiveOfferForm &&
            <RadioGroup
                id='priceType'
                label={Tr('price_type_form')}
                formikProps={formikProps}
                items={PriceTypeItems}
                required
                disabled={!creatingDemand}
            />
            }
            {!passiveOfferForm &&
            <HelpComponent text={Tr('tooltip_auction_made')}>
                <RadioGroup
                    id='auctionMade'
                    label={Tr('choose_best_offer_question')}
                    formikProps={formikProps}
                    items={booleanValues}
                    required
                />
            </HelpComponent>
            }
            <HelpComponent text={Tr(nonpublicProcedure ? 'tooltip_cpv_nonpublic' : 'tooltip_cpv')}>
                <CPVInput
                    id='categoryItemCpv'
                    formikProps={formikProps}
                    required
                    disabled={!creatingDemand}
                    label={Tr(nonpublicProcedure ? 'cpv_code_nonpublic' : 'cpv_code')}
                />
            </HelpComponent>
            {!nonpublicProcedure &&
            <Box component="div" className={classes.uploadFile}>
                <UploadFile
                    id='fundingInstitutionLogo'
                    formikProps={formikProps}
                    label={Tr("funding_institution_logo")}
                    acceptExtensionList={['jpg', 'jpeg', 'png']}
                />
            </Box>
            }
        </GridBlock>
    )
}

RequiredFields.propTypes = {
    classes: PropTypes.any,
    formikProps: PropTypes.object,
}

RequiredFields.defaultProps = {}

export default withStyles(style)(RequiredFields);